export default function SmartExtras() {
  return (
    <section
      id="smart-extras"
      className="lg:tw-py-20 tw-py-10  tw-bg-gradient-to-br tw-from-blue-50 tw-to-orange-50"
    >
      <div className="tw-max-w-6xl tw-mx-auto tw-px-6">
        <div className="tw-text-center lg:tw-mb-16">
          <h2 className="tw-text-2xl lg:tw-text-4xl tw-font-bold tw-text-fintoo-blue tw-mb-6">
            Add More Protection, Your Way
          </h2>
        </div>

        <div className="tw-grid tw-grid-cols-2 lg:tw-grid-cols-4 tlg:w-gap-8 tw-gap-3">
          {/* Card 1 */}
          <div className="tw-bg-white/80 tw-backdrop-blur-sm tw-rounded-2xl tw-p-6 tw-text-center tw-shadow-lg tw-border tw-border-solid tw-border-gray-200">
            <div className="tw-w-16 tw-h-16 tw-bg-gradient-to-br tw-from-red-500 tw-to-red-600 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-6">
              <i className="fa-solid fa-heartbeat tw-text-white tw-text-2xl"></i>
            </div>
            <h3 className="tw-text-lg tw-font-bold tw-text-fintoo-blue tw-mb-3 tw-pb-0">
              Critical Illness Cover
            </h3>
            <p className="tw-text-gray-600 tw-text-sm">
              Shield against life’s uncertainties
            </p>
          </div>

          {/* Card 2 */}
          <div className="tw-bg-white/80 tw-backdrop-blur-sm tw-rounded-2xl tw-p-6 tw-text-center tw-shadow-lg tw-border tw-border-solid tw-border-gray-200">
            <div className="tw-w-16 tw-h-16 tw-bg-fintoo-orange tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-6">
              <i className="fa-solid fa-car-crash tw-text-white tw-text-2xl"></i>
            </div>
            <h3 className="tw-text-lg tw-font-bold tw-text-fintoo-blue tw-mb-3 tw-pb-0">
              Accidental Death Cover
            </h3>
            <p className="tw-text-gray-600 tw-text-sm">
              Extra security for your loved ones
            </p>
          </div>

          {/* Card 3 */}
          <div className="tw-bg-white/80 tw-backdrop-blur-sm tw-rounded-2xl tw-p-6 tw-text-center tw-shadow-lg tw-border tw-border-solid tw-border-gray-200">
            <div className="tw-w-16 tw-h-16 tw-bg-gradient-to-b tw-from-fintoo-blue tw-to-[#1b53a3] tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-6">
              <i className="fa-solid fa-pause tw-text-white tw-text-2xl"></i>
            </div>
            <h3 className="tw-text-lg tw-font-bold tw-text-fintoo-blue tw-mb-3 tw-pb-0">
              Waiver of Premium
            </h3>
            <p className="tw-text-gray-600 tw-text-sm">
              Continue cover even if income stops
            </p>
          </div>

          {/* Card 4 */}
          <div className="tw-bg-white/80 tw-backdrop-blur-sm tw-rounded-2xl tw-p-6 tw-text-center tw-shadow-lg tw-border tw-border-solid tw-border-gray-200">
            <div className="tw-w-16 tw-h-16 tw-bg-gradient-to-br tw-from-green-500 tw-to-green-600 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-6">
              <i className="fa-solid fa-coins tw-text-white tw-text-2xl"></i>
            </div>
            <h3 className="tw-text-lg tw-font-bold tw-text-fintoo-blue tw-mb-3 tw-pb-0">
              Income Benefit Plan
            </h3>
            <p className="tw-text-gray-600 tw-text-sm">
              Monthly income for your family
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
